import { ArrowRight, MapPin } from "lucide-react";
import { HERO_IMAGE, BRAND } from "@/lib/content";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[92vh] w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Propriété entretenue par FBSERVICES"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/65 via-black/45 to-black/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 pb-24 md:pt-48 md:pb-32">
        <div className="max-w-3xl">
          <div
            data-testid="hero-eyebrow"
            className="reveal inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur-md px-4 py-1.5 text-xs uppercase tracking-widest text-white border border-white/20"
          >
            <MapPin className="h-3.5 w-3.5" />
            Basé à {BRAND.city} · Provence
          </div>

          <h1
            data-testid="hero-title"
            className="reveal reveal-delay-1 mt-6 font-display font-semibold text-white text-4xl sm:text-5xl lg:text-7xl tracking-tighter leading-[1.02]"
          >
            Entretien complet de votre propriété.
            <span className="block text-[#D4A373] mt-2">
              Intérieur comme extérieur.
            </span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="reveal reveal-delay-2 mt-6 max-w-xl text-base sm:text-lg text-white/85 leading-relaxed"
          >
            FBSERVICES réunit le savoir-faire d'une équipe de nettoyage professionnelle
            et d'un service d'entretien d'espaces verts. Un seul interlocuteur,
            une qualité constante.
          </p>

          <div className="reveal reveal-delay-3 mt-10 flex flex-wrap gap-3">
            <a
              href="#contact"
              data-testid="hero-cta-nettoyage"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium bg-white text-[#1A4331] hover:bg-[#F3F4F1] transition-all duration-300 group"
            >
              Devis Nettoyage
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-espaces-verts"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium bg-[#1A4331] text-white hover:bg-[#123022] transition-all duration-300 group border border-white/20"
            >
              Devis Espaces Verts
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          {/* Stats strip */}
          <div className="reveal reveal-delay-4 mt-16 grid grid-cols-3 max-w-md gap-6">
            {[
              { value: "+10", label: "Ans d'expérience" },
              { value: "100%", label: "Devis gratuit" },
              { value: "7j/7", label: "Réactivité" },
            ].map((s) => (
              <div key={s.label} className="text-white">
                <div className="font-display text-3xl font-semibold">{s.value}</div>
                <div className="mt-1 text-xs uppercase tracking-wider text-white/70">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
